import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { colors } from "UI/colors";

export function NoticeMessage({
  align = "center",
  children,
  styles,
  style,
  ...rest
}) {
  return (
    <Wrapper
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0, overflow: "hidden" }}
      style={style || styles}
      className="FnrNoticeMessage"
      {...rest}
    >
      <Inside align={align}>{children}</Inside>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  box-sizing: border-box;
`;
const Inside = styled.div`
  border: 1px solid ${colors.fnRedNotice};
  border-radius: 8px;
  background: ${colors.fnYellowNotice};
  color: ${colors.fnRedNotice};

  text-align: ${({ align }) => align};

  padding: 12px;
  font-size: 14px;
  font-weight: 400;
`;

export const NoticeTitle = styled.div`
  font-weight: 400;
  text-align: left;
`;
